'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _lodash = require('lodash');

var _reactRedux = require('react-redux');

var _bdcoreUtilities = require('@bd/bdcore-utilities');

var _selectors = require('./selectors');

var _actions = require('./actions');

var _actions2 = require('../Filters/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setSingleAreaFilter(area, subArea, _ref, store) {
  var filters = _ref.filters,
      _ref$cloudData = _ref.cloudData;
  _ref$cloudData = _ref$cloudData === undefined ? {} : _ref$cloudData;
  var builder = _ref$cloudData.builder;

  var newFilters = {};
  var metroProduct = (0, _lodash.get)(builder, _bdcoreUtilities.ConfigStore.getConfig('builder_id') + '.data.products.BDWebsiteMetros.isPurchased', false);

  if (area) {
    if (area.isMetro && metroProduct) {
      newFilters.AreaMetro = { label: area.name, value: area };
    } else if (area.parentMetro && metroProduct) {
      newFilters.AreaSubMetro = { label: area.name, value: area };
    } else {
      newFilters.Area = { label: area.name, value: area };
    }
  }

  if (subArea && metroProduct) {
    newFilters.AreaSubMetro = { label: subArea.name, value: subArea };
  }

  store.dispatch((0, _actions2.setFilter)('Area', (0, _lodash.get)(newFilters, 'Area')));
  store.dispatch((0, _actions2.setFilter)('AreaMetro', (0, _lodash.get)(newFilters, 'AreaMetro')));
  store.dispatch((0, _actions2.setFilter)('AreaSubMetro', (0, _lodash.get)(newFilters, 'AreaSubMetro')));
}

function setMultiAreaFilter(queryFilters, areas, store) {
  var queryFiltersState = (0, _keys2.default)(queryFilters).filter(function (filter) {
    return ['Area', 'AreaMetro', 'AreaSubMetro'].includes(filter);
  }).reduce(function (result, key) {
    return (0, _extends4.default)({}, result, (0, _defineProperty3.default)({}, key, (0, _lodash.get)(queryFilters, key, []).map(function (value) {
      return { value: areas.find(function (a) {
          return a.name === value;
        }), label: value };
    })));
  }, {});

  (0, _keys2.default)(queryFiltersState).forEach(function (filter) {
    store.dispatch((0, _actions2.setFilter)(filter, queryFiltersState[filter]));
  });
}

var AreaUrlWatcher = function (_React$Component) {
  (0, _inherits3.default)(AreaUrlWatcher, _React$Component);

  function AreaUrlWatcher() {
    (0, _classCallCheck3.default)(this, AreaUrlWatcher);
    return (0, _possibleConstructorReturn3.default)(this, (AreaUrlWatcher.__proto__ || (0, _getPrototypeOf2.default)(AreaUrlWatcher)).apply(this, arguments));
  }

  (0, _createClass3.default)(AreaUrlWatcher, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var store = this.context.store;


      store.dispatch((0, _actions.fetchBuilderIfNeeded)());
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleArea();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.handleArea();
    }
  }, {
    key: 'handleArea',
    value: function handleArea() {
      var match = this.props.match;
      var store = this.context.store;


      var query = _queryString2.default.parse(window.location.search);
      var queryFilters = (0, _lodash.has)(query, 'filters') ? JSON.parse(query.filters) : {};

      if ((0, _lodash.has)(queryFilters, 'Area') || (0, _lodash.has)(queryFilters, 'AreaMetro') || (0, _lodash.has)(queryFilters, 'AreaSubMetro')) {
        setMultiAreaFilter(queryFilters, (0, _selectors.getAreas)(store.getState(), { all: true }), store);
      } else {
        var area = (0, _selectors.getArea)(store.getState(), { match: match }) || (0, _selectors.getMetro)(store.getState(), { match: match });
        var subArea = (0, _selectors.getSubMetro)(store.getState(), { match: match });
        setSingleAreaFilter(area, subArea, store.getState(), store);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return AreaUrlWatcher;
}(_react2.default.Component);

AreaUrlWatcher.propTypes = {
  match: _propTypes2.default.object.isRequired
};

AreaUrlWatcher.contextTypes = {
  store: _propTypes2.default.object
};

exports.default = (0, _reactRedux.connect)(function (_ref2) {
  var _ref2$cloudData = _ref2.cloudData;
  _ref2$cloudData = _ref2$cloudData === undefined ? {} : _ref2$cloudData;
  var builder = _ref2$cloudData.builder;
  return { isLoaded: (0, _keys2.default)(builder).reduce(function (r, b) {
      return builder[b].isFetching || r;
    }, false) };
})(AreaUrlWatcher);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Builder/AreaUrlWatcher.js
// module id = 613
// module chunks = 0